import React from "react";

const clients = [
  "Google",
  "Amazon",
  "Oracle",
  "VMware",
  "Intel",
  "ABB",
  "ANSR Global",
  "NetApp",
  "Colliers",
  "JLL",
  "CBRE",
  "DWP Interics",
];

export default function ClientsMarquee() {
  const looped = [...clients, ...clients];

  return (
    <section
      data-testid="clients-marquee-section"
      className="bg-bgalt border-y border-line py-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-6 flex items-center justify-between">
        <p className="mono-label">Trusted across Fortune-500 sites</p>
        <p className="mono-label hidden sm:block">EHS Award Recipients ↗</p>
      </div>

      <div
        data-testid="client-marquee"
        className="relative w-full overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
        }}
      >
        <div className="marquee-track flex items-center gap-16 whitespace-nowrap w-max">
          {looped.map((name, i) => (
            <span
              key={i}
              data-testid={`client-logo-${i}`}
              className="font-display text-4xl md:text-5xl uppercase tracking-tight text-ink/30 hover:text-ink transition-colors"
            >
              {name}
              <span className="text-accent-red">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
